import { createReducer, on } from '@ngrx/store';
import { PanelActions } from "@store/doc-viewer/panel/panel.actions";
import { cloneDeep } from 'lodash-es';
import { DocViewerState } from "@store/doc-viewer/doc-viewer.state";
import { redactionEditorActions } from '../redaction-editor/redaction-editor.actions';
import { annotationEditorActions } from '../annotation-editor/annotation-editor.actions';

export const panelReducer = createReducer<DocViewerState['panels']>(
	{},
	on(PanelActions.collapsePanel, (_state, { panelId }) => {
		const clone = cloneDeep(_state);
		if (!clone?.[panelId]) {
			clone[panelId] = {} as any;
		}
		clone[panelId].state = 'collapsed';
		return clone;
	}),
	on(PanelActions.expandPanel, (_state, { panelId }) => {
		const clone = cloneDeep(_state);
		if (!clone?.[panelId]) {
			clone[panelId] = {} as any;
		}
		clone[panelId].state = 'expanded';
		return clone;
	}),
	on(PanelActions.setPanelStates, (_state, { panelStates }) => {
		return cloneDeep(panelStates);
	}),
	on(redactionEditorActions.goToPage, (_state, { pageNum }) => {
		const panelId = `expandable-redaction-panel-page-${pageNum}`;
		const clone = cloneDeep(_state);
		if (!clone?.[panelId]) {
			clone[panelId] = {} as any;
		}
		if (clone[panelId].state !== 'expanded')
			clone[panelId].state = 'expanded';
		const filteredRecords = Object.fromEntries(
			Object.entries(_state)
				.filter(([key]) => key.startsWith('expandable-redaction-panel-page-'))
		);
		const panelsToCollapse = Object.fromEntries(
			Object.entries(filteredRecords)
				.filter(([key]) => key !== panelId)
		);
		for (const [key,] of Object.entries(panelsToCollapse)) {
			if (clone?.[key])
				clone[key].state = 'collapsed';
		}
		return clone;
	}),
	on(annotationEditorActions.goToPage, (_state, { pageNum }) => {
		const panelId = `expandable-annotation-panel-page-${pageNum}`;
		const clone = cloneDeep(_state);
		if (!clone?.[panelId]) {
			clone[panelId] = {} as any;
		}
		if (clone[panelId].state !== 'expanded')
			clone[panelId].state = 'expanded';
		const filteredRecords = Object.fromEntries(
			Object.entries(_state)
				.filter(([key]) => key.startsWith('expandable-annotation-panel-page-'))
		);
		const panelsToCollapse = Object.fromEntries(
			Object.entries(filteredRecords)
				.filter(([key]) => key !== panelId)
		);
		for (const [key,] of Object.entries(panelsToCollapse)) {
			if (clone?.[key])
				clone[key].state = 'collapsed';
		}
		return clone;
	}),
);




